export default "__VITE_ASSET__CQqBlifi__"